import { render, staticRenderFns } from "./Soil.vue?vue&type=template&id=467a2458&scoped=true&"
import script from "./Soil.vue?vue&type=script&lang=js&"
export * from "./Soil.vue?vue&type=script&lang=js&"
import style0 from "./Soil.vue?vue&type=style&index=0&id=467a2458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a2458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/gcorso/Developing/vuefarm/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VContainer,VImg})
